<template>
  <div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
    >
      <el-table-column
        label="ID"
        align="center"
        prop="id"
        width="100"
      ></el-table-column>

      <el-table-column
        align="center"
        label="商品封面"
        prop="storeGoodsCover"
        width="100"
      >
        <template slot-scope="scope">
          <el-image
            :src="scope.row.cover"
            fit="scale-down"
            style="width: 70px; height: 70px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品名" prop="name" width="260">
      </el-table-column>
      <el-table-column
        align="center"
        label="商品类型"
        prop="classifyName"
        width="140"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="商品规格"
        min-width="360"
        prop="parameters"
      >
        <template slot-scope="{ row }">
          <div
            v-for="(item, index) in row.commoditSpecificationsList"
            :key="index"
          >
            <span>全款众筹价：{{ item.crowdfundingPrice || 0 }}；</span>
            <span>抽奖众筹价：{{ item.crowdfundingLotteryPrice || 0 }}；</span>
            <span v-if="row.isGift == 1"
              >库存：{{ item.inventory || 0 }}；</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="参与数"
        prop="salesVolume"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="160"
      >
        <template slot-scope="scope">
          <el-button
            v-if="hasAuth('sys:send:detail')"
            plain
            type="primary"
            @click="lookinfo(scope.row)"
            >参与详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :total="total"
    ></el-pagination>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="visible"
      append-to-body
      class="dialogClass"
      title="众筹参与详情"
      top="5vh"
      width="80%"
    >
      <div>
        <el-table
          ref="multipleTable"
          :data="tableOrderData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          stripe
        >
          <el-table-column
            label="订单号"
            align="center"
            prop="orderCode"
            width="200"
          >
            <template slot-scope="scope">
              <span
                style="cursor: pointer; color: #fc8c23"
                @click="ChangeBill(scope.row)"
                >{{ scope.row.orderCode }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            label="用户昵称"
            align="center"
            prop="nickName"
            width="160"
          >
          </el-table-column>
          <el-table-column
            label="用户头像"
            align="center"
            prop="updateTime"
            width="160"
          >
            <template slot-scope="{ row }">
              <el-image
                :src="row.avatarUrl"
                fit="scale-down"
                style="width: 40px; height: 40px; border-radius: 50%"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column
            label="众筹类型"
            align="center"
            prop="updateTime"
            width="160"
          >
            <template slot-scope="{ row }">
              <span v-if="row.isCrowdfunding == 1">全款众筹</span>
              <span v-if="row.isCrowdfunding == 2">众筹抽奖</span>
            </template>
          </el-table-column>
          <el-table-column
            label="众筹抽奖是否中奖"
            align="center"
            prop="updateTime"
            width="160"
          >
            <template slot-scope="{ row }">
              <div v-if="row.isCrowdfunding == 2">
                <span v-if="row.isCrowdfundingLottery == 1" style="color: red"
                  >已中奖</span
                >
                <span v-if="row.isCrowdfundingLottery == 2">未中奖</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
            prop="createTime"
            width="160"
          ></el-table-column>
          <el-table-column
            label="支付时间"
            align="center"
            prop="payTime"
            width="160"
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleOrderSizeChange"
          @current-change="handleOrderCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="orderForm.pageNo"
          :page-size="orderForm.pageSize"
          :total="orderTotal"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "crowdfunding",
  data() {
    return {
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        isCrowdfunding: 1,
      },
      tableData: [],
      multipleSelection: [],
      total: 0,
      tableOrderData: [],
      orderTotal: 0,
      visible: false,
      orderForm: {
        id: null,
        pageNo: 1,
        pageSize: 10,
        isCrowdfunding: 1,
      },
    };
  },
  created() {
    this.getConfig();
  },
  methods: {
    ChangeBill(row) {
      this.$router.push({
        path: "/sys/bill",
        query: {
          orderCode: row.orderCode,
        },
      });
    },
    lookinfo(row) {
      this.orderForm.id = row.id;
      this.visible = true;
      this.getOrder();
    },
    getConfig() {
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    getOrder() {
      this.$axios
        .post("/admin/order/getCrowdfundingOrderList", this.orderForm)
        .then((res) => {
          this.tableOrderData = res.data.records;
          this.orderTotal = res.data.total;
        });
    },
    handleSizeChange(i) {
      this.searchForm.pageSize = i;
      this.getConfig();
    },

    handleCurrentChange(i) {
      this.searchForm.pageNo = i;
      this.getConfig();
    },
    handleOrderSizeChange(i) {
      this.orderForm.pageSize = i;
      this.getOrder();
    },

    handleOrderCurrentChange(i) {
      this.orderForm.pageNo = i;
      this.getOrder();
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
